export default "__VITE_ASSET__fa94d6cc__"